/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M8 1.5h8c3.5899 0 6.5 2.9101 6.5 6.5v8c0 3.5899-2.9101 6.5-6.5 6.5H8c-3.5899 0-6.5-2.9101-6.5-6.5V8c0-3.5899 2.9101-6.5 6.5-6.5ZM0 8c0-4.4183 3.5817-8 8-8h8c4.4183 0 8 3.5817 8 8v8c0 4.4183-3.5817 8-8 8H8c-4.4183 0-8-3.5817-8-8V8Zm9.7828 6.3146h-3.264l-1.0802 3.3515H3.5L7.2397 6.3h1.808l3.7551 11.3661h-1.9546l-1.0654-3.3515ZM8.3504 9.7799a25.9473 25.9473 0 0 1-.2077-.693c-.0351.1276-.0715.2522-.109.3738l-.9646 3.128h2.1624l-.881-2.8088Zm8.0858 6.3397V7.8909l-2.1825-.148V6.3444H20.5v1.3985l-2.1752.148v8.2287l2.1752.148v1.3985h-6.2463v-1.3986l2.1825-.1479Z"
    clipRule="evenodd"
  />,
  'MenuAI'
);
